import React from "react";
import { Header, Paragraph, Tag, useColorTokens } from "@tvg/design-system";
import { RunnerBI } from "../../../../hooks/useGetRunnerFromBI";
import {
  FavTagContainer,
  MLContainer,
  OddsButton,
  OddsContainer
} from "./styled-components";

interface OddsButtonProps {
  runnerBI: RunnerBI;
  activeButtons: boolean[];
  onClickBetButton: (
    type: string,
    isActive: boolean,
    position?: number
  ) => void;
}

const OddsButtonComp = ({
  runnerBI,
  activeButtons,
  onClickBetButton
}: OddsButtonProps) => {
  const colorTokens = useColorTokens();

  if (runnerBI.isScratched) {
    return (
      <OddsContainer data-qa-label="race-card-odds-container">
        <Tag
          size="m"
          variant="info"
          label="Scratched"
          qaLabel="race-card-scratched-label"
        />
        <Paragraph
          qaLabel="race-card-morning-line-odd"
          color={colorTokens.content.subtle}
          fontSize="xs"
          mt="space-1"
          opacity={0.4}
        >
          {`ML ${runnerBI.morningLineOdd}`}
        </Paragraph>
      </OddsContainer>
    );
  }

  return (
    <OddsContainer data-qa-label="race-card-odds-container">
      <OddsButton
        isFavorite={runnerBI.isFavorite}
        data-qa-label="race-card-odds-button"
        isSelected={activeButtons[0]}
        onClick={() => onClickBetButton("win", activeButtons[0], 0)}
      >
        {runnerBI.isFavorite && !runnerBI.isScratched && (
          <FavTagContainer data-qa-label="race-card-favorite-tag">
            <Tag size="s" variant="fav" label="FAV" />
          </FavTagContainer>
        )}
        <Header
          tag="h3"
          fontFamily="medium"
          qaLabel="race-card-current-odd"
          color={
            activeButtons[0]
              ? colorTokens.component.button.secondary.content.active
              : colorTokens.component.button.tertiary.content.base
          }
        >
          {runnerBI.currentOdd}
        </Header>
        <MLContainer>
          <Paragraph
            qaLabel="race-card-morning-line-odd"
            color={
              activeButtons[0]
                ? colorTokens.component.button.secondary.content.active
                : colorTokens.component.button.tertiary.content.base
            }
            fontSize="xs"
          >
            {`ML ${runnerBI.morningLineOdd}`}
          </Paragraph>
        </MLContainer>
      </OddsButton>
    </OddsContainer>
  );
};

export default OddsButtonComp;
